import { RepliesViews } from 'enums/replies/views';
import { Subscribable } from 'knockout';
import IdeationManager from 'managers/ideation';
import { IWCCStorageManager } from 'managers/iStorage';
import CommentRepliesManager from 'managers/topic/comment/replies';
import { TopicThread } from 'models/topicThread';

function isInToDoList(thread: TopicThread) {
    return thread.isInToDoList();
}

function isReported(thread: TopicThread) {
    return thread.spamComplaintCount() > 0;
}

export default class CommentToDoManager {
    isInToDoList: Subscribable<boolean>
    isReported: Subscribable<boolean>

    isInToDoListOrReported = ko.pureComputed(() => this.isInToDoList() || this.isReported())

    constructor(
        comment: Subscribable<TopicThread | undefined>,
        storage: IWCCStorageManager
    ) {
        const commentId = comment.pluck('id');
        const topicId = comment.pluck('topicId');
        const isReply = comment.mapNotNull(c => (c.parentId() ?? '').length > 0).default(false);        
        const hasNoInitialReplies = comment.mapNotNull(c => c.repliesCount() === 0).default(false);

        const ideationManager = storage.get(IdeationManager, { topicId });
        const ideationReady = ideationManager.pluck(m => m.isReady, false);
        const isVotingStage = ideationManager.pluck(m => m.isVotingStage, false);

        const repliesView = ko.pureComputed<RepliesViews | undefined>(() => ideationReady() ? isVotingStage() ? 'myvotes' : 'all' : undefined);

        const repliesManager = storage.get(CommentRepliesManager, { commentId, topicId, isEmpty: hasNoInitialReplies, view: repliesView });
        const replies = repliesManager.pluck('replies', []);

        this.isInToDoList = comment.mapNotNull(c => isInToDoList(c) || (!isReply() && replies().some(r => isInToDoList(r)))).default(false);
        this.isReported = comment.mapNotNull(c => isReported(c) || (!isReply() && replies().some(r => isReported(r)))).default(false);
    }
}